import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APP_CONFIG } from "../../../core/config/app-config";
import { NotificationPage } from "../models/notification.models";

@Injectable({ providedIn: "root" })
export class NotificationApiService {
    private readonly http = inject(HttpClient);
    private readonly config = inject(APP_CONFIG);
    private readonly baseUrl = `${this.config.apiBaseUrl}/servpushnote/notifications`;

    getAll(latestId?: string | null): Observable<NotificationPage> {
        const params = latestId
            ? new HttpParams().set("latestId", latestId)
            : undefined;
        return this.http.get<NotificationPage>(`${this.baseUrl}/all`, {
            params,
        });
    }

    setSeen(typeId: string, seen: boolean): Observable<unknown> {
        return this.http.patch(
            `${this.baseUrl}/set/one/seen/${encodeURIComponent(typeId)}/${seen}`,
            {}
        );
    }
}
